import axios from "axios";
import { API_URL } from "../../const";

export const listPreProsal = (fetchData: JSON) => {
  const data = {
    GetAllPreLeadToken: fetchData,
  };
  const url = `${API_URL}GetAllPreLead`;
  return axios.post(url, data, {
    headers: { "Content-type": "application/json" },
  });
};

/***************** END PREPROSAL LIST  ******************/

export const searchPreProsal = (fetchData: JSON) => {
  const data = {
    FetchPreproposalToken: fetchData,
  };
  const url = `${API_URL}FetchPreProposalDetails`;
  return axios.post(url, data, {
    headers: { "Content-type": "application/json" },
  });
};

/***************** END PREPROSAL SEARCH  ******************/

export const pushProposalsToDialer = (fetchData: JSON) => {
  // Encrypted endpoint (PushToDialler module) — replaces the legacy
  // uploadPreLeadToTCN.php standalone script.
  const data = { PushPreLeadToTCNToken: fetchData };
  const url = `${API_URL}PushPreLeadToTCN`;
  return axios
    .post(url, data, { headers: { "Content-type": "application/json" } })
    .then((response) => response.data);
};

/***************** END PUSH TO DIALER  ******************/
